// Amber "this looks like a total" box rendered under a supplement-request
// input. Shared by TransitionButton, the Finance card's upload form, and the
// ScopeSection editor so all three warn identically. Rule + rationale live in
// lib/supplementEntryGuard.ts. Sep 15, 2026.

import { supplementEntryWarning } from "../../lib/supplementEntryGuard";

const money = (n: number) =>
  "$" + n.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function SupplementEntryWarning({
  entered,
  rcv,
  onUse,
}: {
  entered: number;
  rcv: number;
  /** Called with the suggested added amount when the user taps "Use". */
  onUse?: (amount: number) => void;
}) {
  const w = supplementEntryWarning(entered, rcv);
  if (!w) return null;
  const suggest = w.suggest;
  return (
    <div className="mt-1.5 rounded-lg border border-amber-300 bg-amber-50 px-2.5 py-2 text-[11px] leading-snug text-amber-900">
      <div className="font-semibold">⚠ This looks like Apex's whole estimate, not the added amount</div>
      <div className="mt-0.5">
        {money(entered)} is {w.pct}% of the carrier's RCV ({money(rcv)}). This field should hold only what was requested on
        top of the carrier's estimate.
        {suggest == null && " Read the added amount off the Apex document."}
      </div>
      {suggest != null && (
        <div className="mt-1.5 flex flex-wrap items-center gap-2">
          {onUse && (
            <button
              type="button"
              onClick={() => onUse(suggest)}
              className="inline-flex items-center rounded-md bg-amber-600 px-2.5 py-1 text-[11px] font-semibold text-white hover:bg-amber-700"
            >
              Use {money(suggest)} (entered − RCV)
            </button>
          )}
          <span className="text-[10px] text-amber-700">or keep as entered if this really is the added amount</span>
        </div>
      )}
    </div>
  );
}
